import axios from "axios";
import { getUrl } from "@/common/config";
export default class MachinesAlarmsApi {
  constructor() {
    this.url = getUrl();
  }

  /*
   * Get last 24h alarms state
   */
  async getMachineAlarms(machineId) {
    const url = `${this.url}/alarm-events/state`;

    return machineId
      ? axios
          .get(url, {
            params: {
              machineId
            }
          })
          .then(response => response.data)
      : undefined;
  }

  /*
   * Search params:
   * @param: machineId, string
   * @param: alarm-code, encoded string
   * @param: skip
   * @param: limit
   * @param: before, string iso date
   * @param: after, string iso date
   */
  getMachineAlarmsHistory(machineId, alarmCode, search) {
    const url = `${this.url}/alarm-events/history`;
    const params = {
      ...search,
      "alarm-code": encodeURIComponent(alarmCode),
      machineId
    };

    return axios.get(url, { params }).then(response => response.data);
  }
}
